import React from "react";

/* 
 * 
 * Wraps content in <  />
 * 
 */
export const HeaderLink = (props) => <b className={`${props.className} header-link`}>
  <span>{"<"}</span><b>{props.text || props.children}</b><span>{"/>"}</span>
</b>;